import { LABEL_CLASS, SELECT_CLASS } from "../report-styles";
import { GRACE_OPTIONS } from "../report-utils";

interface Props {
  value: number;
  onChange: (value: number) => void;
}

export const GraceControl = ({ value, onChange }: Props) => (
  <label className={LABEL_CLASS}>
    Grace period
    <select
      aria-label="Grace period"
      value={value}
      onChange={event => onChange(Number(event.target.value))}
      className={SELECT_CLASS}
    >
      {(GRACE_OPTIONS as readonly number[]).includes(value) ? null : <option value={value}>{value} days</option>}
      {GRACE_OPTIONS.map(option => (
        <option key={option} value={option}>
          {option === 0 ? "None" : `${option} days`}
        </option>
      ))}
    </select>
  </label>
);
